export default __webpack_public_path__ + "static/media/CHEM.f39e42b9.jpg";